import {
  type ContextType,
  type Dispatch,
  type FC,
  type PropsWithChildren,
  type SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react';

type DrawerState =
  | { open: false }
  | { open: true; type: 'global-tag'; isEditing: false }
  | { open: true; type: 'global-tag'; isEditing: true; id: string }
  | { open: true; type: 'local-tag'; isEditing: false }
  | { open: true; type: 'local-tag'; isEditing: true; id: string }
  | { open: true; type: 'bulk-tag' };

const Context = createContext<
  | {
      drawerState: DrawerState;
      setDrawerState: Dispatch<SetStateAction<DrawerState>>;
    }
  | undefined
>(undefined);

const _useContext = (): NonNullable<ContextType<typeof Context>> => {
  const context = useContext(Context);
  if (!context) {
    throw new Error('useDrawerState must be used within DrawerProvider.');
  }
  return context;
};

export const useDrawerState = () => {
  return _useContext();
};

const _DrawerStateProvider: FC<PropsWithChildren> = ({ children }) => {
  const [drawerState, setDrawerState] = useState<DrawerState>({ open: false });

  return (
    <Context.Provider value={{ drawerState, setDrawerState }}>
      {children}
    </Context.Provider>
  );
};
